<template>
    <v-app-bar app class="white">
        <v-toolbar-title class="headline text-uppercase">
            <span><img class="site-logo" src="../../assets/logo.png"></span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            text
            :href="dashboardUrl"
        >
            <span class="mr-2" v-html="`< ${$t('global-terms.back-to-dashboard')}`"></span>
        </v-btn>
    </v-app-bar>
</template>
<script>
export default {
  name: 'base-header',
  computed: {
    dashboardUrl () {
      return `${process.env.VUE_APP_EZ_HOST}/owner-area/dashboard`
    },
  },
}
</script>
<style lang="scss" scoped>
    img.site-logo {
        margin-top:10px;
        height: 40px;
    }
</style>
